module.exports = __webpack_public_path__ + "static/media/Stormwater2.8beb1257.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav2/Stormwater2.jpg
// module id = 753
// module chunks = 0